if (window.matchMedia('(max-width: 767px)').matches) {
    //スマホ処理
} else if (window.matchMedia('(min-width:768px)').matches) {
    //PC処理
}

$(function(){
      $('.featured-collections-wrapper .keep-spacing .homepage-collection-grid-item').matchHeight();
      $('.homepage-product-grid-wrapper .product-grid--title').matchHeight();
      $('.grid-view-item').matchHeight();
      $('.collection-grid--title, .product-grid--title').matchHeight();
      $('.homepage-sections-wrapper--white .grid-item-details--below-image .grid-item__title').matchHeight();
});

/***** switcher *****/
  $(function () {
    var paraGety = function paraGety(para) {
      var pageURL = window.location.search.substring(1),
      urlValue = pageURL.split('&'), paraName;
      for(var i = 0; i < urlValue.length; i++) {
        paraName = urlValue[i].split('=');
        if (paraName[0] === para) {
          return paraName[1] === undefined ? true : decodeURIComponent(paraName[1]);
        }
      }
    };
    var result = paraGety('currency');
    var cry = (result == undefined) ? 'jpy' : (result == 'jpy') ? 'jpy' : (result == 'usd') ? 'usd' : (result == 'cad') ? 'cad' : (result == 'aud') ? 'aud' : (result == 'gbp') ? 'gbp' : (result == 'eur') ? 'eur' : (result == 'cny') ? 'cny' : (result == 'krw') ? 'krw' : (result == 'hkd') ? 'hkd' : (result == 'twd') ? 'twd' : '';
    $('section.modal_switcher > nav > dl:nth-of-type(2) > dd#'+ cry +' > a').css({background: '#000', color: '#fff'});
  });

  $(function() {
    $('.switcher_box dt').on('click', function() {
      $('.switcher_box dd').toggleClass('show').removeClass('hide');
    });
  });
/***** /switcher *****/

/***** accordion *****/
  $(function() {
    $('#AddToCart').on('click', function() {
      $('p.cart-all').addClass('show');
    });
  });

  /* buy-detail */
    $(function() {
      $('ul.buy_detail h3').on('click', function() {
        $(this).toggleClass('open');
        $(this).next('dl').toggleClass('open');
        // $(this).parent('dl.acd').toggleClass('acd_open');
        // $(this).next().children('p').slideToggle(500);
        // $(this).next('dl > dt').slideToggle(500);
        // $(this).next('dl > dd:not(.payicon)').slideToggle(500);
      });
    });
  /* /buy-detail */

  /* collection filter */
    $(function() {
      $('p.facets__heading').on('click', function() {
        $(this).siblings('details').toggleClass('collection_filter_show');
      });
    });
    
    $(function() {
      $('.disclosure-has-popup').on('click', function() {
        // $('.disclosure-has-popup').toggleClass('collection_filter_show');
        // $('.disclosure-has-popup').removeClass('collection_filter_show');
        // $(this).addClass('collection_filter_show');
      });
    });

    $(function() {
      $('label.collection-filters__label').on('click', function() {
        $(this).next('div.select').toggleClass('collection_filter_show');
      });
    });
  /* /collection filter */

  /* order_list */
    $(function() {
      $('div.order_list > div').on('click', function() {
        $(this).toggleClass('order_detail_show');
      });
    });
  /* /order_list */
/***** /accordion *****/

$(function () {
  $(".js-accordion-title").on("click", function() {
    $(this).next().slideToggle(200);
    $(this).toggleClass("open",200);
  });
});

/***** 汎用アコーディオン *****/
  document.addEventListener('click', (event) => {
    let title = event.target.closest('.acdn_btn');
      if( title ) {
      let item = title.closest('.acdn');
      let panel = item.querySelector('.acdn_btn');
      panel.classList.toggle('acdn_show');
    }
  });
/***** /汎用アコーディオン *****/

/*****  商品詳細ページ購入ボタンポップアップ ******/
function popupDiv(show){
  console.log('商品詳細ページ購入ボタンポップアップ');
  const div = document.querySelector("#div_popup"); 
  if(show){
    div.style.display = "flex";
    div.style.opacity = 0;
    div.style.transition = "opacity 0.3s";
    setTimeout(() => { div.style.opacity = 1; }, 1500);
  } else {
    div.style.transition = "opacity 0.3s";
    div.style.opacity = 0;
    setTimeout(() => { div.style.display = "none"; }, 1500);
  }
}

/***** POPUP画像にリンク追加 2026/08/12 *****/
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.popup_image.newsletter-top').forEach(function(el) {
    el.addEventListener('click', function() {
      window.open('https://xxxxx.com/pages/users-guide#pickup', '_blank');
    });
  });
});

/***** タイマータグ 2026/08/12 *****/
var myClass = document.getElementsByClassName("timerHidden");
for (var i = 0; i < myClass.length; i++){
    var appearTime = myClass[i].getAttribute("data-appear_time");
    var disappearTime = myClass[i].getAttribute("data-disappear_time");
    var threshould_start = Date.parse(appearTime);
    var threshould_end = Date.parse(disappearTime);
    var current = new Date();
    if (threshould_start < current && threshould_end > current) {
      // HTMLで設定した期間
      myClass[i].classList.add("timerVisible");
    } else {
      // 上の期間外の場合
      myClass[i].classList.remove("timerVisible");
    }
}